import openInClientStore from './openInClientStore';
import strings from 'owa-strings/owa-mail-strings';
import { AddinIcons } from 'owa-addins-icons';
import { IconType } from 'office-ui-fabric-react/lib/Icon';
import {
    IContextualMenuItem,
    ContextualMenuItemType,
} from 'office-ui-fabric-react/lib/ContextualMenu';

export function createAddinMarketplaceItem(): IContextualMenuItem {
    return {
        key: 'AddinMarketplace',
        name: strings.manageAddins,
        title: strings.manageAddins,
        ariaLabel: strings.manageAddins,
        iconProps: {
            iconName: AddinIcons.AddIn,
            iconType: IconType.default,
        },
        itemType: ContextualMenuItemType.Normal,
        onClick: () => {
            openInClientStore();
        },
    };
}

export function createDivider(): IContextualMenuItem {
    return {
        key: 'AddinMarketplaceDivider',
        displayName: '-',
        itemType: ContextualMenuItemType.Divider,
        iconProps: {
            iconName: AddinIcons.AddIn,
            iconType: IconType.default,
        },
        onClick: null,
    };
}
